import styles from './dropdown.module.css';
import { useNavigate } from 'react-router-dom';
import { memo } from 'react';
import { buttonsData } from './dropdown.helper';


const ProfileDropdown = ({ togglePopup, setOpen }) => {
  const navigate = useNavigate()
  function accFunc() {
    setOpen(false)
    navigate('/account')
  }
  return (
    <>
      <div className={styles.buttonsContainer}>
        {buttonsData(accFunc, togglePopup, navigate).map((btn) => (
          <div key={btn.id} className={btn.className} onClick={btn.onClick}>
            <img alt={btn.label} src={btn.icon} className={styles.personIcon} />
            <p style={{ color: "#000000" }}>{btn.label}</p>
          </div>
        ))}
      </div>
    </>
  );
};

export default memo(ProfileDropdown);
